import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { useNavigate, Link, useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import AdminApiModule from "../../components/AdminApi/Api/api";
import Chip from "@mui/material/Chip";
import ListItemText from "@mui/material/ListItemText";
import ImageIcon from "@mui/icons-material/Image";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Button from "@mui/material/Button";
import axios from "axios";
import { useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import { BASE_URL } from "../../components/config/config";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Snackbar,
  Alert,
} from "@mui/material";
import "./veiwTicket.css";
import { styled } from "@mui/material/styles";

// Import permission utilities
import {
  canUpdateSpecificRequirement,
  canBroadcastTicket,
  canPartRequestTicket,
  canViewPartRequestTicketList,
  canUpdateTicket,
  canCancelTicket,
  canRemarkTicket,
  canRefundTicketAmount,
  canViewBroadcastedList,
  canViewContactNumber,
  canUpdateCenter,
  hasFullAccess,
} from "../../utility/permissionUtils";

// Import the new components
import BroadcastList from "./Pop-up/ViewTicketComponets/BroadcastList";
import RefundModal from "./Pop-up/ViewTicketComponets/RefundModal";
import RemarkModal from "./Pop-up/ViewTicketComponets/RemarkModal";
import CancelModal from "./Pop-up/ViewTicketComponets/CancelModal";
import PartRequestModal from "./Pop-up/ViewTicketComponets/PartRequestModal";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.type === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing[1],
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function ViewTicket() {
  const navigate = useNavigate();
  let location = useLocation();
  const globalState = useSelector((state) => state.AdminReducer);
  const accessToken = globalState?.userTokens?.accessToken;
  const userPermissions = globalState?.adminDetails?.role_id?.permissions;

  const ticketData = location?.state?.ticketData || null;
  let ticketId = location?.search
    ? new URLSearchParams(location.search).get("ticketId")
    : null;
  const remarksFromDocument = location.state?.remarks || "";
  const [isLoading, setIsLoading] = useState(false);
  const [doesTicketExists, setDoesTicketExists] = useState(false);
  const [ticketDetails, setTicketDetails] = useState({});
  const [feedBackList, setFeedBackList] = useState({});
  const [broadCastList, setBroadCastList] = useState([]);
  const [remarkModalOpen, setRemarkModalOpen] = useState(false);
  const [remarkValue, setRemarkValue] = useState("");
  const [ticketIdd, setTicketId] = useState(null);
  const [centerObjId, setCenterObjId] = useState(null);
  const [technicianMessage, setTechnicianMessage] = useState("");
  const [specificRequirement, setSpecificRequirement] = useState("");
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [refundModalOpen, setRefundModalOpen] = useState(false);
  const [refundType, setRefundType] = useState("");
  const [refundAmount, setRefundAmount] = useState("");
  const [refundRemarks, setRefundRemarks] = useState("");
  const [centerObjIdd, setCenterObjIdd] = useState(null);
  const [ticketObjId, setTicketObjId] = useState(null);
  const [isBroadcasted, setIsBroadcasted] = useState(false);
  const [name, setName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [partRequestModalOpen, setPartRequestModalOpen] = useState(false);
  const [partDescription, setPartDescription] = useState("");
  const [isSubmittingPartRequest, setIsSubmittingPartRequest] = useState(false);
  const [partRequests, setPartRequests] = useState([]);
  const [isLoadingPartRequests, setIsLoadingPartRequests] = useState(false);

  const [toast, setToast] = useState({
    open: false,
    msg: "",
    duration: 5000,
    type: "success",
  });

  // Permission checks
  const canUpdateSpecificReq = canUpdateSpecificRequirement(userPermissions);
  const canBroadcast = canBroadcastTicket(userPermissions);
  const canRequestPart = canPartRequestTicket(userPermissions);
  const canViewPartRequests = canViewPartRequestTicketList(userPermissions);
  const canEditTicket = canUpdateTicket(userPermissions);
  const canCancel = canCancelTicket(userPermissions);
  const canAddRemark = canRemarkTicket(userPermissions);
  const canRefund = canRefundTicketAmount(userPermissions);
  const canViewBroadcastList = canViewBroadcastedList(userPermissions);
  const canViewNumbers = canViewContactNumber(userPermissions);
  const canEditCenter = canUpdateCenter(userPermissions);
  const hasFullTicketAccess = hasFullAccess(userPermissions);

  const startLoading = () => setIsLoading(true);
  const stopLoading = () => setIsLoading(false);

  // Helper function to get color based on status
  const getStatusColor = (status) => {
    switch (status) {
      case "ON_HOLD":
        return "#f44336"; // Red
      case "CLOSED":
        return "#ff9dab "; // Pink
      case "ACCEPTED":
        return "#4caf50"; // Green
      case "CANCEL":
        return "#f44336"; // Red
      case "PENDING":
        return "#ff9800"; // Yellow
      case "IN_PROGRESS":
        return "#9c27b0"; // Purple
      case "ASSIGNED":
        return "#009688"; // Teal
      default:
        return "#757575";
    }
  };

  // Helper function to get color for part request status
  const getPartRequestStatusColor = (status) => {
    switch (status) {
      case "PENDING":
        return "#ff9800"; // Orange
      case "APPROVED":
        return "#4caf50"; // Green
      case "REJECTED":
        return "#f44336"; // Red
      case "COMPLETED":
        return "#2196f3"; // Blue
      default:
        return "#757575"; // Grey
    }
  };

  useEffect(() => {
    getAllTickets(ticketId);
  }, []);

  useEffect(() => {
    setSpecificRequirement(ticketDetails?.specific_requirement || "");
  }, [ticketDetails]);

  useEffect(() => {
    if (ticketDetails?._id && canViewPartRequests) {
      getPartRequests(ticketDetails._id);
    }
  }, [ticketDetails, canViewPartRequests]);

  const getPartRequests = async (ticketObjId) => {
    if (!ticketObjId) return;

    setIsLoadingPartRequests(true);
    try {
      const response = await axios.get(
        `${BASE_URL}client/get-part-approval-tickets?ticket_obj_id=${ticketObjId}`,
        {
          headers: {
            "x-access-token": accessToken,
          },
        },
      );

      if (response.data.success) {
        // The API returns data in response.data.data array
        setPartRequests(response.data.data || []);
      } else {
        setPartRequests([]);
        console.error("Failed to fetch part requests:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching part requests:", error);
      setPartRequests([]);
    } finally {
      setIsLoadingPartRequests(false);
    }
  };

  const downloadImage = (url, fileName) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Helper function to sort broadcast list
  const sortBroadcastList = (list) => {
    if (!list || !Array.isArray(list)) return list;

    return [...list].sort((a, b) => {
      // First layer: Sort by wallet balance (higher balance first)
      const balanceA = Number(a?.technician_wallet?.balance || 0);
      const balanceB = Number(b?.technician_wallet?.balance || 0);

      if (balanceA !== balanceB) {
        return balanceB - balanceA; // Descending order (higher first)
      }

      // Second layer: Sort by last active (latest active first)
      const lastActiveA = a?.center_obj_id?.updatedAt
        ? new Date(a.center_obj_id.updatedAt).getTime()
        : 0;
      const lastActiveB = b?.center_obj_id?.updatedAt
        ? new Date(b.center_obj_id.updatedAt).getTime()
        : 0;

      return lastActiveB - lastActiveA; // Descending order (latest first)
    });
  };

  const getAllTickets = (ticketId) => {
    startLoading();
    let payload = {
      ticket_obj_id: ticketId,
    };
    new AdminApiModule()
      .getSingleTicket(payload)
      .then((res) => {
        if (res?.data?.results?.length) {
          setDoesTicketExists(true);
          setTicketDetails(res?.data?.results?.[0]);
          setFeedBackList(res?.data?.feedBackList?.[0]);
          // Sort the broadcast list before setting it
          const sortedBroadcastList = sortBroadcastList(
            res?.data?.broadCastList,
          );
          setBroadCastList(sortedBroadcastList);
        }
        stopLoading();
      })
      .catch((err) => {
        stopLoading();
      });
  };

  const handleWhatsAppClick = (
    phoneNumber,
    locality,
    city,
    service,
    pincode,
  ) => {
    if (!canViewNumbers) {
      showDialog(
        true,
        "error",
        "You don't have permission to view contact numbers",
      );
      return;
    }

    const formattedPhoneNumber = phoneNumber.replace(/[^\d]/g, "");
    const message = `
नमस्ते 
We have a lead in *${pincode} ,${locality}, ${city}* (as soon as possible) - *${service}* 
If interested,
Playstore se Update kariye - OniT Partners App https://play.google.com/store/apps/details?id=com.onit.partners
नई लीड्स एक्सेप्ट करने के लिए KYC कंप्लीट करिए (profile verification compulsory)
वॉलेट में मिनिमम 99/– होना चाहिए
Profile se apna QR share karte rahiye aur www.onit.services par FREE listing se bina commision unlimited leads paaiye 🫱🏻‍🫲🏼!
Call / WhatsApp helpdesk on *9205460202*
Reply *Interested* / *Not Interested* on this message 🙏🏻
`;

    const encodedMessage = encodeURIComponent(message);

    window.open(
      `https://web.whatsapp.com/send?phone=${formattedPhoneNumber}&text=${encodedMessage}`,
      "_blank",
    );
  };

  const handleWhatsAppClick1 = (number, name) => {
    if (!canViewNumbers) {
      showDialog(
        true,
        "error",
        "You don't have permission to view contact numbers",
      );
      return;
    }

    if (number) {
      const formattedPhoneNumber = number.replace(/[^\d]/g, "");
      const message = `Dear ${name} its being long since we served you, just wanted to remind about Onit Services for any of your Home Services `;
      const encodedMessage = encodeURIComponent(message);
      window.open(
        `https://web.whatsapp.com/send?phone=${formattedPhoneNumber}&text=${encodedMessage}`,
        "_blank",
      );
    } else {
      console.error("Phone number is not defined or invalid");
    }
  };

  const handleSubmitReq = (ticketobjid) => {
    if (!canUpdateSpecificReq) {
      showDialog(
        true,
        "error",
        "You don't have permission to update specific requirements",
      );
      return;
    }

    const payload = {
      new_requirement: specificRequirement,
      ticket_obj_id: ticketobjid,
    };
    fetch(`${BASE_URL}admin/update-specific-requirement`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (response.ok) {
          console.log("Requirements saved successfully");
          showDialog(true, "success", "Requirements updated successfully");
        } else {
          console.error("Error saving requirements");
          showDialog(true, "error", "Error saving requirements");
        }
      })
      .catch((error) => {
        console.error("Error saving requiremnets:", error);
        showDialog(true, "error", "Error saving requirements");
      });
  };

  const handleOpenRemarkModal = (
    ticketId,
    centerId,
    technicianMessage,
    name,
  ) => {
    if (!canAddRemark) {
      showDialog(true, "error", "You don't have permission to add remarks");
      return;
    }
    setRemarkModalOpen(true);
    setTicketId(ticketId);
    setCenterObjId(centerId);
    setTechnicianMessage(technicianMessage);
    setName(name);
  };

  const handleCloseRemarkModal = () => {
    setRemarkModalOpen(false);
    setRemarkValue("");
    navigate(`/view-ticket?ticketId=${ticketDetails?._id}`);
  };

  const handleEditCenter = (id) => {
    if (!canEditCenter) {
      showDialog(true, "error", "You don't have permission to edit centers");
      return;
    }
    navigate("/add-center?edit=" + id);
  };

  const showDialog = (open, type, msg) => {
    setToast({ open, msg, duration: 5000, type });
  };

  const handleOpenRefundModal = (centerId, ticketId) => {
    if (!canRefund) {
      showDialog(true, "error", "You don't have permission to process refunds");
      return;
    }
    setCenterObjIdd(centerId);
    setTicketObjId(ticketId);
    setRefundModalOpen(true);
  };

  const handleCloseRefundModal = () => {
    setRefundModalOpen(false);
    setCenterObjIdd(null);
    setTicketObjId(null);
  };

  const handleRefundSubmit = () => {
    if (!refundType || !refundAmount || !refundRemarks) {
      alert("Please fill in all fields.");
      return;
    }
    const payload = {
      ticket_obj_id: ticketObjId,
      center_obj_id: centerObjIdd,
      refundRemarks,
      refundAmount,
      refundType,
      Name: globalState?.adminDetails?.user_name,
    };
    fetch(`${BASE_URL}admin/send-refund-in-wallet-technician`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Refund response:", data);
        showDialog(
          true,
          data.success === 1 ? "success" : "error",
          data.message,
        );
      })
      .catch((error) => {
        console.error("Error in refund:", error);
        showDialog(
          true,
          "error",
          "An error occurred while processing the refund.",
        );
      });
    setToast({
      open: true,
      msg: "Refund processed successfully",
      type: "success",
      duration: 3000,
    });
    setRefundType("");
    setRefundAmount("");
    setRefundRemarks("");
    handleCloseRefundModal();
  };

  const broadcast = (id) => {
    if (!canBroadcast) {
      showDialog(
        true,
        "error",
        "You don't have permission to broadcast tickets",
      );
      return;
    }

    const apiUrl = `${BASE_URL}technicianApp/ticket-broadcast`;
    const requestData = {
      ticket_obj_id: id,
    };
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        showDialog(true, "success", "Request broadcasted successfully");
        setIsBroadcasted(true);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
        showDialog(true, "error", "Failed to broadcast request");
        setIsBroadcasted(false);
      });
  };

  const editticket = (id) => {
    if (!canEditTicket) {
      showDialog(true, "error", "You don't have permission to edit tickets");
      return;
    }
    navigate("/admin-ticket?edit=" + id);
  };

  const CancelTicket = async (id, name, remarks) => {
    if (!canCancel) {
      showDialog(true, "error", "You don't have permission to cancel tickets");
      return;
    }

    try {
      await axios.post(`${BASE_URL}admin/onboarding-team-remarks`, {
        onboarding_team_remarks: remarks,
        onboarding_team_name: name,
        ticket_obj_id: id,
      });
      console.log("Remarks updated successfully.");
      await axios.put(`${BASE_URL}admin/cancelTickets/${id}`);
      console.log("Request cancelled successfully.");
      handleCloseCancelModal();
      showDialog(true, "success", "Ticket cancelled successfully");
    } catch (error) {
      console.error("Error cancelling the request:", error);
      showDialog(true, "error", "Error cancelling ticket");
    }
  };

  const handleSaveRemark = (ticketIdd, centerObjId) => {
    const payload = {
      ticket_obj_id: ticketIdd,
      center_obj_id: centerObjId,
      onboarding_technician_remarks: remarkValue,
      onboarding_team_name: globalState?.adminDetails?.user_name,
    };
    fetch(`${BASE_URL}admin/add-broadcast-remarks-team`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (response.ok) {
          console.log("Remark saved successfully");
          handleCloseRemarkModal();
          showDialog(true, "success", "Remark added successfully");
          window.location.reload();
        } else {
          console.error("Error saving remark");
          handleCloseRemarkModal();
          showDialog(true, "error", "Error saving remark");
        }
      })
      .catch((error) => {
        console.error("Error saving remark:", error);
        handleCloseRemarkModal();
        showDialog(true, "error", "Error saving remark");
      });
  };

  // Handle Part Request Submission
  const handlePartRequestSubmit = () => {
    if (!canRequestPart) {
      showDialog(true, "error", "You don't have permission to request parts");
      return;
    }

    if (!partDescription.trim()) {
      showDialog(true, "error", "Please enter part description");
      return;
    }

    setIsSubmittingPartRequest(true);

    const payload = {
      ticket_obj_id: ticketDetails?._id,
      part_request_description: partDescription.trim(),
    };

    fetch(`${BASE_URL}admin/request-client-to-part-by-admin`, {
      method: "POST",
      headers: {
        "x-access-token": accessToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        setIsSubmittingPartRequest(false);
        if (data.success) {
          showDialog(
            true,
            "success",
            data.message || "Part request submitted successfully",
          );
          handleClosePartRequestModal();
          // Refresh part requests list after successful submission
          getPartRequests(ticketDetails?._id);
        } else {
          showDialog(
            true,
            "error",
            data.message || "Failed to submit part request",
          );
        }
      })
      .catch((error) => {
        setIsSubmittingPartRequest(false);
        console.error("Error submitting part request:", error);
        showDialog(
          true,
          "error",
          "An error occurred while submitting part request",
        );
      });
  };

  //  Close Modal
  const handleClosePartRequestModal = () => {
    setPartRequestModalOpen(false);
    setPartDescription("");
  };

  const handleCloseCancelModal = () => setCancelModalOpen(false);

  // Open Modal
  const handleOpenPartRequestModal = () => {
    if (!canRequestPart) {
      showDialog(true, "error", "You don't have permission to request parts");
      return;
    }
    setPartRequestModalOpen(true);
  };

  const handleOpenCancelModal = () => {
    if (!canCancel) {
      showDialog(true, "error", "You don't have permission to cancel tickets");
      return;
    }
    setCancelModalOpen(true);
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  // Helper to get part request status
  const getPartRequestStatus = (partRequest) => {
    if (partRequest.part_request_status) {
      // Convert to uppercase for consistent comparison
      const status = partRequest.part_request_status.toUpperCase();
      return status === "APPROVED" ? "APPROVED" : "REJECTED";
    }
    return "PENDING";
  };

  // Helper to get client remarks
  const getClientRemarks = (partRequest) => {
    return partRequest.clientActionDescription || "Waiting for client response";
  };

  if (isLoading) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
        onClick={stopLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (!doesTicketExists) {
    return <>Invalid Request id </>;
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <div>
        <Link to="/all-tickets">
          <IconButton
            color="primary"
            aria-label="back"
            sx={{ position: "absolute", top: 16, left: 16 }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Link>
      </div>

      {/* First Row of Tables */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Left table content */}
        <Box sx={{ width: "48%" }}>
          <TableContainer component={Paper}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    Request Id:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.ticket_id}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    Request status:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    <Chip
                      label={ticketDetails?.ticket_status}
                      sx={{
                        height: "30px",
                        backgroundColor: getStatusColor(
                          ticketDetails?.ticket_status,
                        ),
                        color: "white",
                        fontWeight: "bold",
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    Request closing price:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.closing_ticket_price
                      ? ticketDetails?.closing_ticket_price
                      : "NIL"}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    Request created by:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.create_name}
                  </TableCell>
                </TableRow>
                {canUpdateSpecificReq && (
                  <TableRow>
                    <TableCell
                      sx={{ border: "1px solid #ccc", padding: "8px" }}
                    >
                      Specific Requirements:
                    </TableCell>
                    <TableCell
                      sx={{ border: "1px solid #ccc", padding: "8px" }}
                    >
                      <TextField
                        value={specificRequirement}
                        onChange={(e) => setSpecificRequirement(e.target.value)}
                        fullWidth
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleSubmitReq(ticketDetails?._id)}
                      >
                        Submit
                      </Button>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Right table content */}
        <Box sx={{ width: "48%" }}>
          <TableContainer component={Paper}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Operation Team Remarks:
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    {ticketDetails?.remarks?.onboarding_team_remarks} -{" "}
                    {ticketDetails?.remarks?.onboarding_team_name}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    Is Technician Assigned:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    <Chip
                      label={
                        ticketDetails?.is_technician_assigned
                          ? "Assigned"
                          : "Not Assigned"
                      }
                      sx={{ height: "20px" }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    Broadcast status:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    <Chip
                      label={ticketDetails?.broadcast_status}
                      sx={{ height: "20px" }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    Happy Code:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    <Chip
                      label={ticketDetails?.code?.happy_code}
                      sx={{ height: "20px" }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    Unhappy Code:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    <Chip
                      label={ticketDetails?.code?.unhappy_code}
                      sx={{ height: "20px" }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    Start Code:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    <Chip
                      label={ticketDetails?.code?.start_code}
                      sx={{ height: "20px" }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    Offer Code:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    <Chip
                      label={ticketDetails?.offers_applied?.offer_code}
                      sx={{ height: "20px" }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    Happy/Unhappy:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    <Chip
                      label={ticketDetails?.remarks?.message}
                      sx={{ height: "20px" }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      {/* Second Row of Tables */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        {/* Left table content */}
        <Box sx={{ width: "48%" }}>
          <TableContainer component={Paper}>
            <Table>
              <TableBody>
                {ticketDetails?.revisit_status && (
                  <>
                    <TableRow>
                      <TableCell
                        sx={{
                          border: "2px solid black",
                          padding: "8px",
                          fontWeight: "bold",
                        }}
                      >
                        Revisit Status:
                      </TableCell>
                      <TableCell
                        sx={{ border: "2px solid black", padding: "8px" }}
                      >
                        {ticketDetails?.ticket_revisit_status}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          border: "2px solid black",
                          padding: "8px",
                          fontWeight: "bold",
                        }}
                      >
                        Revisit Price:
                      </TableCell>
                      <TableCell
                        sx={{ border: "2px solid black", padding: "8px" }}
                      >
                        {ticketDetails?.revisit_price}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          border: "2px solid black",
                          padding: "8px",
                          fontWeight: "bold",
                        }}
                      >
                        Revisit Remarks:
                      </TableCell>
                      <TableCell
                        sx={{ border: "2px solid black", padding: "8px" }}
                      >
                        {ticketDetails?.remarks?.revisit_remarks}
                      </TableCell>
                    </TableRow>
                  </>
                )}
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Created At:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {new Date(ticketDetails?.createdAt).toLocaleString(
                      "en-IN",
                      {
                        timeZone: "Asia/Kolkata",
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        second: "numeric",
                        hour12: true,
                      },
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Accepted At:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.acceptedAt
                      ? new Date(ticketDetails.acceptedAt).toLocaleString(
                          "en-IN",
                          {
                            timeZone: "Asia/Kolkata",
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            second: "numeric",
                            hour12: true,
                          },
                        )
                      : "----"}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Assigned At:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.assignedAt
                      ? new Date(ticketDetails.assignedAt).toLocaleString(
                          "en-IN",
                          {
                            timeZone: "Asia/Kolkata",
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            second: "numeric",
                            hour12: true,
                          },
                        )
                      : "----"}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Closed At:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.closedAt
                      ? new Date(ticketDetails.closedAt).toLocaleString(
                          "en-IN",
                          {
                            timeZone: "Asia/Kolkata",
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            second: "numeric",
                            hour12: true,
                          },
                        )
                      : "----"}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Service provided for:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.service_provided_for?.service_name}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Right table content */}
        <Box sx={{ width: "48%" }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Remarks
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Request closure remarks:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.remarks?.technician_remarks}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Serial Number:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.serial_number}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Verified remarks:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.remarks?.admin_remarks}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Verified By:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.approved_by}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Customer Remarks:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.messages?.customer_message}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      {/* Customer Details and Assigned Details Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        {/* Left Column - Customer Details */}
        <Box sx={{ width: "48%" }}>
          <Paper sx={{ p: 2 }}>
            <Typography
              variant="h5"
              sx={{
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Customer Details
              {canViewNumbers && (
                <IconButton
                  onClick={() =>
                    handleWhatsAppClick1(
                      ticketDetails?.personal_details?.alternate_phone
                        ?.mobile_number ||
                        ticketDetails?.personal_details?.primary_phone
                          ?.mobile_number,
                      ticketDetails?.personal_details?.name,
                    )
                  }
                  sx={{ marginLeft: "auto", fontSize: "1.5rem" }}
                >
                  <WhatsAppIcon
                    sx={{ color: "green", fontSize: "2.5rem", padding: "1px" }}
                  />
                </IconButton>
              )}
            </Typography>
            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar alt="Customer" src="/static/images/avatar/1.jpg" />
                </ListItemAvatar>
                <ListItemText
                  primary="Customer Name"
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >
                        {ticketDetails?.personal_details?.name}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" />
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar alt="Customer" src="/static/images/avatar/2.jpg" />
                </ListItemAvatar>
                <ListItemText
                  primary="Customer Phone"
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >
                        {canViewNumbers
                          ? ticketDetails?.personal_details?.primary_phone
                              ?.country_code +
                            "  " +
                            ticketDetails?.personal_details?.primary_phone
                              ?.mobile_number
                          : "******" +
                            (ticketDetails?.personal_details?.primary_phone?.mobile_number?.slice(
                              -4,
                            ) || "****")}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" />
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar alt="Address" src="/static/images/avatar/3.jpg" />
                </ListItemAvatar>
                <ListItemText
                  primary="Address details"
                  secondary={
                    <React.Fragment>
                      <Box component="div">
                        {"House Number" +
                          " -  " +
                          ticketDetails?.address_details?.house_number}
                      </Box>
                      <Box component="div">
                        {"Locality" +
                          " -  " +
                          ticketDetails?.address_details?.locality}
                      </Box>
                      <Box component="div">
                        {"Pincode" +
                          " -  " +
                          ticketDetails?.address_details?.pincode}
                      </Box>
                      <Box component="div">
                        {"City" + " -  " + ticketDetails?.address_details?.city}
                      </Box>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        component="div"
                      >
                        <Typography
                          component="span"
                          variant="body2"
                          color="text.primary"
                        >
                          {"State" +
                            " -  " +
                            ticketDetails?.address_details?.state}
                        </Typography>
                        <a
                          href={`https://app.onit.services/#/ServiceStatus/?${ticketDetails?._id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ fontWeight: "bold", color: "red" }}
                        >
                          Tracking Link
                        </a>
                      </Box>
                    </React.Fragment>
                  }
                />
              </ListItem>
            </List>
          </Paper>

          {/* Closure Details */}
          <TableContainer component={Paper} sx={{ marginTop: "20px" }}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{
                      border: "1px solid #ccc",
                      fontWeight: "bold",
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    Closure Details of Client Request
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      fontWeight: "bold",
                      padding: "8px",
                    }}
                  >
                    Client ID :
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.service_provided_client_id}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      fontWeight: "bold",
                      padding: "8px",
                    }}
                  >
                    Payment Mode :
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.payment_type}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      fontWeight: "bold",
                      padding: "8px",
                    }}
                  >
                    Date of Purchase(Customer):
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.date_of_purchase}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      fontWeight: "bold",
                      padding: "8px",
                    }}
                  >
                    Due Amount :
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.service_provided_due_amount}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      fontWeight: "bold",
                      padding: "8px",
                    }}
                  >
                    Addtional Charges :
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.ticket_price}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      fontWeight: "bold",
                      padding: "8px",
                    }}
                  >
                    Platform Share Amount :
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.ticket_closing_platform_share_amount}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      fontWeight: "bold",
                      padding: "8px",
                    }}
                  >
                    Closing Total Amount :
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.ticket_closing_total_amount}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Right Column - Assigned Details and Pictures */}
        <Box sx={{ width: "48%" }}>
          {/* Assigned Details */}
          <TableContainer component={Paper}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{
                      border: "1px solid #ccc",
                      fontWeight: "bold",
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    Assigned Details
                  </TableCell>
                </TableRow>
                {ticketDetails?.is_technician_assigned ? (
                  <>
                    <TableRow>
                      <TableCell
                        sx={{
                          border: "1px solid #ccc",
                          fontWeight: "bold",
                          padding: "8px",
                        }}
                      >
                        Assigned Center Name:
                      </TableCell>
                      <TableCell
                        sx={{ border: "1px solid #ccc", padding: "8px" }}
                      >
                        {
                          ticketDetails?.assigned_ids?.assigned_center_id
                            ?.center_name
                        }
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          border: "1px solid #ccc",
                          fontWeight: "bold",
                          padding: "8px",
                        }}
                      >
                        Assigned Center address:
                      </TableCell>
                      <TableCell
                        sx={{ border: "1px solid #ccc", padding: "8px" }}
                      >
                        {ticketDetails?.assigned_ids?.assigned_center_id
                          ?.address_details?.address_line &&
                          `${ticketDetails?.assigned_ids?.assigned_center_id?.address_details?.address_line} - `}
                        {ticketDetails?.assigned_ids?.assigned_center_id
                          ?.address_details?.city &&
                          `${ticketDetails?.assigned_ids?.assigned_center_id?.address_details?.city} - `}
                        {ticketDetails?.assigned_ids?.assigned_center_id
                          ?.address_details?.state &&
                          `${ticketDetails?.assigned_ids?.assigned_center_id?.address_details?.state} - `}
                        {ticketDetails?.assigned_ids?.assigned_center_id
                          ?.address_details?.country &&
                          `${ticketDetails?.assigned_ids?.assigned_center_id?.address_details?.country} - `}
                        {ticketDetails?.assigned_ids?.assigned_center_id
                          ?.address_details?.pincode &&
                          `${ticketDetails?.assigned_ids?.assigned_center_id?.address_details?.pincode}`}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          border: "1px solid #ccc",
                          fontWeight: "bold",
                          padding: "8px",
                        }}
                      >
                        Center INA Code:
                      </TableCell>
                      <TableCell
                        sx={{ border: "1px solid #ccc", padding: "8px" }}
                      >
                        {
                          ticketDetails?.assigned_ids?.assigned_center_id
                            ?.qr_details?.qr_id
                        }
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          border: "1px solid #ccc",
                          fontWeight: "bold",
                          padding: "8px",
                        }}
                      >
                        Assigned Technician Name:
                      </TableCell>
                      <TableCell
                        sx={{ border: "1px solid #ccc", padding: "8px" }}
                      >
                        {
                          ticketDetails?.assigned_ids?.assigned_technician_id
                            ?.personal_details?.name
                        }
                      </TableCell>
                    </TableRow>
                  </>
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={2}
                      sx={{ border: "1px solid #ccc", padding: "8px" }}
                    >
                      Not assigned
                    </TableCell>
                  </TableRow>
                )}
                <TableRow>
                  <TableCell
                    sx={{
                      border: "1px solid #ccc",
                      fontWeight: "bold",
                      padding: "8px",
                    }}
                  >
                    Customer Called Technician:
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #ccc", padding: "8px" }}>
                    {ticketDetails?.call_count?.consumer_call_count}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* Onsite Pictures section */}
          <Paper sx={{ marginTop: "20px", p: 2 }}>
            <Typography variant="h5">Onsite Pictures</Typography>
            <List
              sx={{
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                gap: "0",
                bgcolor: "background.paper",
                margin: 0,
                padding: 0,
              }}
            >
              {ticketDetails?.onsite_pictures?.length ? (
                ticketDetails.onsite_pictures.map((image, index) => (
                  <ListItem
                    key={index}
                    sx={{ flex: "0 0 calc(25.33% - 8px)", padding: 0 }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: 0,
                      }}
                    >
                      <ListItemAvatar>
                        <Avatar
                          sx={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "0",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setSelectedImage(image);
                            setImageModalOpen(true);
                          }}
                        >
                          <img
                            src={image}
                            alt={`Onsite Image ${index + 1}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </Avatar>
                      </ListItemAvatar>
                      <Box sx={{ marginTop: "8px", padding: 0 }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            downloadImage(image, `OnsiteImage${index + 1}.png`)
                          }
                          sx={{ width: "100%", height: "20px", padding: 0 }}
                        >
                          Download
                        </Button>
                      </Box>
                    </Box>
                  </ListItem>
                ))
              ) : (
                <Typography>No onsite pictures available</Typography>
              )}
            </List>
          </Paper>

          {/* Client Pictures section - NEW SECTION */}
          <Paper sx={{ marginTop: "20px", p: 2 }}>
            <Typography variant="h5">Client Pictures</Typography>
            <List
              sx={{
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                gap: "0",
                bgcolor: "background.paper",
                margin: 0,
                padding: 0,
              }}
            >
              {ticketDetails?.client_onsite_pictures?.length ? (
                ticketDetails.client_onsite_pictures.map((image, index) => (
                  <ListItem
                    key={index}
                    sx={{ flex: "0 0 calc(25.33% - 8px)", padding: 0 }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: 0,
                      }}
                    >
                      <ListItemAvatar>
                        <Avatar
                          sx={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "0",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setSelectedImage(image);
                            setImageModalOpen(true);
                          }}
                        >
                          <img
                            src={image}
                            alt={`Client Image ${index + 1}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </Avatar>
                      </ListItemAvatar>
                      <Box sx={{ marginTop: "8px", padding: 0 }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            downloadImage(image, `ClientImage${index + 1}.png`)
                          }
                          sx={{ width: "100%", height: "20px", padding: 0 }}
                        >
                          Download
                        </Button>
                      </Box>
                    </Box>
                  </ListItem>
                ))
              ) : (
                <Typography>No client pictures available</Typography>
              )}
            </List>
          </Paper>

          {/* Warrenty Pictures section - NEW SECTION */}
          <Paper sx={{ marginTop: "20px", p: 2 }}>
            <Typography variant="h5">Warrenty Pictures</Typography>
            <List
              sx={{
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                gap: "0",
                bgcolor: "background.paper",
                margin: 0,
                padding: 0,
              }}
            >
              {ticketDetails?.uploaded_warrenty_documents?.length ? (
                ticketDetails.uploaded_warrenty_documents.map(
                  (image, index) => (
                    <ListItem
                      key={index}
                      sx={{ flex: "0 0 calc(25.33% - 8px)", padding: 0 }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: 0,
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar
                            sx={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "0",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSelectedImage(image);
                              setImageModalOpen(true);
                            }}
                          >
                            <img
                              src={image}
                              alt={`Warrenty Image ${index + 1}`}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </Avatar>
                        </ListItemAvatar>
                        <Box sx={{ marginTop: "8px", padding: 0 }}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() =>
                              downloadImage(
                                image,
                                `WarrentyImage${index + 1}.png`,
                              )
                            }
                            sx={{ width: "100%", height: "20px", padding: 0 }}
                          >
                            Download
                          </Button>
                        </Box>
                      </Box>
                    </ListItem>
                  ),
                )
              ) : (
                <Typography>No warrenty pictures available</Typography>
              )}
            </List>
          </Paper>

          {/* Image Modal for full-size view */}
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={imageModalOpen}
            onClick={() => setImageModalOpen(false)}
          >
            <Box
              sx={{
                maxWidth: "90vw",
                maxHeight: "90vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={selectedImage}
                alt="Full size"
                style={{
                  maxWidth: "100%",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => setImageModalOpen(false)}
                sx={{ mt: 2 }}
              >
                Close
              </Button>
            </Box>
          </Backdrop>

          {/* Action Buttons */}
          <Box sx={{ marginTop: "10px" }}>
            {canBroadcast && (
              <Button
                variant="contained"
                onClick={() => broadcast(ticketDetails?._id)}
                disabled={
                  isBroadcasted ||
                  ["ON_HOLD", "CLOSED", "CANCELLED"].includes(
                    ticketDetails?.ticket_status,
                  ) ||
                  (ticketDetails?.ticket_status === "ACCEPTED" &&
                    ticketDetails?.assigned_ids?.assigned_technician_id !==
                      null)
                }
                sx={{
                  marginRight: "10px",
                  backgroundColor: isBroadcasted
                    ? "green"
                    : ["ON_HOLD", "CLOSED", "CANCELLED"].includes(
                          ticketDetails?.ticket_status,
                        ) ||
                        (ticketDetails?.ticket_status === "ACCEPTED" &&
                          ticketDetails?.assigned_ids
                            ?.assigned_technician_id !== null)
                      ? "#cccccc"
                      : "primary.main",
                  "&:hover": {
                    backgroundColor: isBroadcasted
                      ? "darkgreen"
                      : ["ON_HOLD", "CLOSED", "CANCELLED"].includes(
                            ticketDetails?.ticket_status,
                          ) ||
                          (ticketDetails?.ticket_status === "ACCEPTED" &&
                            ticketDetails?.assigned_ids
                              ?.assigned_technician_id !== null)
                        ? "#cccccc"
                        : "primary.dark",
                  },
                  cursor:
                    ["ON_HOLD", "CLOSED", "CANCELLED"].includes(
                      ticketDetails?.ticket_status,
                    ) ||
                    (ticketDetails?.ticket_status === "ACCEPTED" &&
                      ticketDetails?.assigned_ids?.assigned_technician_id !==
                        null)
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                {isBroadcasted ? "Broadcasted" : "Broadcast"}
              </Button>
            )}

            {canRequestPart && ticketDetails?.ticket_status === "ON_HOLD" && (
              <Button
                variant="contained"
                color="secondary"
                onClick={handleOpenPartRequestModal}
                sx={{
                  marginRight: "10px",
                  backgroundColor: "#ff9800",
                  "&:hover": {
                    backgroundColor: "#f57c00",
                  },
                }}
              >
                Part Request
              </Button>
            )}

            {canEditTicket && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => editticket(ticketDetails?._id)}
                sx={{ marginRight: "10px" }}
              >
                Edit Request
              </Button>
            )}

            {canCancel && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleOpenCancelModal(ticketDetails?._id)}
                sx={{ backgroundColor: "red" }}
              >
                Cancel
              </Button>
            )}
          </Box>
        </Box>
      </Box>

      {/* Part Requests Section - Added above Feedback List */}
      {canViewPartRequests && (
        <Paper sx={{ marginTop: "20px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h5">Part Requests</Typography>
          </Box>

          {isLoadingPartRequests ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
              <CircularProgress size={24} />
            </Box>
          ) : partRequests.length > 0 ? (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Ticket ID</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Total Parts
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Total Price
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Client Response
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Parts List
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {partRequests.map((request, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Typography variant="body2" fontWeight="bold">
                          {request.ticket_id}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={getPartRequestStatus(request)}
                          size="small"
                          sx={{
                            backgroundColor: getPartRequestStatusColor(
                              getPartRequestStatus(request),
                            ),
                            color: "white",
                            fontWeight: "bold",
                          }}
                        />
                      </TableCell>
                      <TableCell>{request.total_part_count || 0}</TableCell>
                      <TableCell>₹{request.total_part_prize || 0}</TableCell>
                      <TableCell>{getClientRemarks(request)}</TableCell>
                      <TableCell>
                        {request.part_details &&
                        request.part_details.length > 0 ? (
                          <Box>
                            {request.part_details.map((part, partIndex) => (
                              <Chip
                                key={partIndex}
                                label={part.part_name}
                                size="small"
                                variant="outlined"
                                sx={{ mr: 0.5, mb: 0.5 }}
                              />
                            ))}
                          </Box>
                        ) : (
                          "No parts specified"
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography
              variant="body1"
              sx={{ textAlign: "center", p: 3, color: "text.secondary" }}
            >
              No part requests found for this ticket.
            </Typography>
          )}
        </Paper>
      )}

      {/* Feedback list section */}
      <Paper sx={{ marginTop: "20px", p: 2 }}>
        <Typography variant="h5">Feed back list</Typography>
        <List sx={{ width: "100%", bgcolor: "background.paper" }}>
          {feedBackList?.feedBackResponse?.length
            ? feedBackList?.feedBackResponse?.map((ite, index) => (
                <ListItem key={index}>
                  <ListItemAvatar>
                    <Avatar>
                      <ImageIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={ite?.question + " ? "}
                    secondary={ite?.answer}
                  />
                </ListItem>
              ))
            : "No feed back given"}
        </List>
      </Paper>

      {/* Broadcast list section - now using the separate component */}
      {canViewBroadcastList && (
        <Paper sx={{ marginTop: "20px", p: 2 }}>
          <Typography variant="h5">Broadcast list</Typography>
          <BroadcastList
            broadCastList={broadCastList}
            ticketDetails={ticketDetails}
            handleWhatsAppClick={handleWhatsAppClick}
            handleOpenRemarkModal={handleOpenRemarkModal}
            handleEditCenter={handleEditCenter}
            handleOpenRefundModal={handleOpenRefundModal}
            userPermissions={userPermissions}
          />
        </Paper>
      )}

      {/* Use the modal components */}
      {canRefund && (
        <RefundModal
          refundModalOpen={refundModalOpen}
          handleCloseRefundModal={handleCloseRefundModal}
          refundType={refundType}
          setRefundType={setRefundType}
          refundAmount={refundAmount}
          setRefundAmount={setRefundAmount}
          refundRemarks={refundRemarks}
          setRefundRemarks={setRefundRemarks}
          handleRefundSubmit={handleRefundSubmit}
        />
      )}

      {canAddRemark && (
        <RemarkModal
          remarkModalOpen={remarkModalOpen}
          handleCloseRemarkModal={handleCloseRemarkModal}
          remarkValue={remarkValue}
          setRemarkValue={setRemarkValue}
          handleSaveRemark={handleSaveRemark}
          ticketIdd={ticketIdd}
          centerObjId={centerObjId}
          technicianMessage={technicianMessage}
          name={name}
        />
      )}

      {canCancel && (
        <CancelModal
          cancelModalOpen={cancelModalOpen}
          handleCloseCancelModal={handleCloseCancelModal}
          remarks={remarks}
          setRemarks={setRemarks}
          CancelTicket={CancelTicket}
          ticketId={ticketId}
          globalState={globalState}
        />
      )}

      {canRequestPart && (
        <PartRequestModal
          partRequestModalOpen={partRequestModalOpen}
          handleClosePartRequestModal={handleClosePartRequestModal}
          partDescription={partDescription}
          setPartDescription={setPartDescription}
          handlePartRequestSubmit={handlePartRequestSubmit}
          isLoading={isSubmittingPartRequest}
        />
      )}

      {/*Snackbar for  details */}
      <Snackbar
        open={toast.open}
        autoHideDuration={toast.duration}
        onClose={() => showDialog(false, toast.type, "")}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => showDialog(false, toast.type, "")}
          severity={toast.type}
          sx={{ width: "100%" }}
        >
          {toast.msg}
        </Alert>
      </Snackbar>
    </Box>
  );
}
